import angular from 'angular';
import _ from 'lodash';

(function() {
    'use strict';
    angular.module('app.core').factory('InvoiceAssociated', InvoiceAssociatedData);

    InvoiceAssociatedData.$inject = ['CONF'];

    /* @ngInject */
    function InvoiceAssociatedData(CONF) {
        InvoiceAssociated.prototype = {
            build: build,
            getPdfLink: getPdfLink
        };

        function InvoiceAssociated(invoiceAssociatedData) {
            if (invoiceAssociatedData) {
                this.build(invoiceAssociatedData);
            }
        }

        return InvoiceAssociated;

        /////////////////////

        function build(invoiceAssociatedData) {
            this.guid = invoiceAssociatedData.guid || null;
            this.number = invoiceAssociatedData.number || null;
            this.date = invoiceAssociatedData.date || null;
            this.type = invoiceAssociatedData.type || null;
            this.exclusiveTaxAmount = invoiceAssociatedData.exclusiveTaxAmount;
            this.taxAmount = invoiceAssociatedData.taxAmount;
            this.netPayable = invoiceAssociatedData.netPayable;
            this.currency = invoiceAssociatedData.currency || null;
            this.orderCompliance = invoiceAssociatedData.orderCompliance || null;
            this.attachments = invoiceAssociatedData.attachments || null;
        }

        /** Fournit l'url pour accéder au pdf de la facture. */
        function getPdfLink() {
            var attachmentPdf = _.filter(this.attachments, { typeDoc: 'INVOICE_PDF' });
            if (attachmentPdf.length == 1) {
                return (
                    CONF.apiContext +
                    CONF.apiBaseUrl +
                    '/v1/invoices/' +
                    this.guid +
                    '/attachment/' +
                    attachmentPdf[0].attachmentId +
                    '?disposition=INLINE'
                );
            }
        }
    }
})();
